import React from 'react';

const Contact = () => {
  return (
    <div>
      Contact Page
    </div>
  )
}

export default Contact;